module.exports = __webpack_public_path__ + "img/Journalism05.63bceb08.png";